import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'p', 'h1', 'h2', 'h3', 'h4', 'em', 'strong', 'b', 'i', 'br', 'img',
  'a', 'ul', 'ol', 'li', 'blockquote', 'span', 'div', 'section',
  'figure', 'figcaption',
];

const ALLOWED_ATTR = [
  'data-para-id', 'data-section-id', 'data-excluded',
  'src', 'alt', 'href', 'id', 'class',
];

/**
 * Sanitizes stored book markup before any browser rendering or pagination path.
 * Editing-only attributes and inline styles are deliberately excluded from previews.
 */
export function sanitizeBookHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
  });
}
